import { render, staticRenderFns } from "./original.vue?vue&type=template&id=656a1649&scoped=true"
import script from "./original.vue?vue&type=script&lang=js"
export * from "./original.vue?vue&type=script&lang=js"
import style0 from "./original.vue?vue&type=style&index=0&id=656a1649&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a1649",
  null
  
)

export default component.exports